import './Display.css';
import Cards from './Card';

function App() {
  const data = [
    {
      name:"Bharath Karthick",
      city:"Madurai",
      role:"MERN Developer",
      skills:["HTML","CSS","Bootstrap","JS","Jquery","React JS","Node Js","Express Js","Mongo DB"],
      work:true,
      image:'./BharathKarthick.jpg'
    },
    {
      name:"Vishwa Vigneshwar",
      city:"Madurai",
      role:"MERN Developer",
      skills:["HTML","CSS","Bootstrap","JS","Jquery","React JS","Node Js","Express Js","Mongo DB"],
      work:true,
      image:'./Vishwa.jpg'
    },
    {
      name:"Vijaya Shankar",
      city:"Madurai",
      role:"MERN Developer",
      skills:["HTML","CSS","Bootstrap","JS","Jquery","React JS","Node Js","Express Js","Mongo DB"],
      work:true,
      image:'./viji.jpg'
    },
    {
      name:"Vicky",
      city:"Madurai",
      role:"MERN Developer",
      skills:["HTML","CSS","Bootstrap","JS","Jquery","React JS","Node Js","Express Js","Mongo DB"],
      work:true,
      image:'./vicky.jpg'
    },
    {
      name:"Bharath Karthick",
      city:"Madurai",
      role:"MERN Developer",
      skills:["HTML","CSS","Bootstrap","JS","Jquery","React JS","Node Js","Express Js","Mongo DB"],
      work:true,
      image:'./BharathKarthick.jpg'
    },
    {
      name:"Vishwa Vigneshwar",
      city:"Madurai",
      role:"MERN Developer",
      skills:["HTML","CSS","Bootstrap","JS","Jquery","React JS","Node Js","Express Js","Mongo DB"],
      work:false,
      image:'./Vishwa.jpg'
    },
    {
      name:"Vijaya Shankar",
      city:"Madurai",
      role:"MERN Developer",
      skills:["HTML","CSS","Bootstrap","JS","Jquery","React JS","Node Js","Express Js","Mongo DB"],
      work:false,
      image:'./viji.jpg'
    },
    {
      name:"Vicky",
      city:"Madurai",
      role:"MERN Developer",
      skills:["HTML","CSS","Bootstrap","JS","Jquery","React JS","Node Js","Express Js","Mongo DB"],
      work:false,
      image:'./vicky.jpg'
    },
    {
      name:"Bharath Karthick",
      city:"Madurai",
      role:"MERN Developer",
      skills:["HTML","CSS","Bootstrap","JS","Jquery","React JS","Node Js","Express Js","Mongo DB"],
      work:false,
      image:'./BharathKarthick.jpg'
    },
    {
      name:"Vishwa Vigneshwar",
      city:"Madurai",
      role:"MERN Developer",
      skills:["HTML","CSS","Bootstrap","JS","Jquery","React JS","Node Js","Express Js","Mongo DB"],
      work:true,
      image:'./Vishwa.jpg'
    }
  ]
  return (
   <>
    {
      data.map((user,index)=>(
        <Cards key = {index} 
              name={user.name}
              city={user.city}
              role={user.role}
              skills={user.skills}
              work={user.work}
              image={user.image}/>
      ))
    }
   </>
  );
}

export default App;
